import { useClientVD } from '@solinkcorp/agent/hooks/useClientVD';
import { honoFetcher } from '@solinkcorp/agent/lib/honoFetcher';
import { useCallback } from 'react';
import { useSWRConfig } from 'swr';

interface UpdateParams {
  id: string;
  title?: string;
  description?: string;
  status?: 'open' | 'archived';
  visibility?: 'public' | 'private';
}

export function useUpdateInvestigation() {
  const client = useClientVD();
  const { mutate } = useSWRConfig();

  const updateInvestigation = useCallback(
    async (params: UpdateParams) => {
      const { id, ...payload } = params;
      const result = await honoFetcher(
        client.investigations[':id'].$put({
          param: { id },
          json: payload,
        }),
      );
      await mutate(
        (key: unknown) =>
          Array.isArray(key) &&
          (key[0] === 'investigations' || (key[0] === 'investigation-detail' && key[1] === id)),
      );
      return result;
    },
    [client, mutate],
  );

  return { updateInvestigation };
}
